import { Catalog } from '@philips-internal/oswald-ui-core';
/**
 * Checks if the node is valid or not.
 *
 * @param nodeType - node type.
 */
function isNodeTypeValid(nodeType) {
    return Catalog.has(nodeType);
}
/**
 * Determines whether all the nodes of a treeview are valid or not.
 *
 * @param node - node element.
 */
function isNodeValid(node) {
    if (!isNodeTypeValid(node.type)) {
        return false;
    }
    if (Array.isArray(node.children)) {
        return node.children.every(isNodeValid);
    }
    return true;
}
export { isNodeTypeValid, isNodeValid, };
//# sourceMappingURL=is-node-valid.js.map